module.exports = "\n"


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/home/mmetatag/mmetatag.component.html
// module id = ../../../../../src/app/home/mmetatag/mmetatag.component.html
// module chunks = common